<template>
  <div class="filter-goods">
    <div class="filter-goods__wrap">
      <el-button
        class="filter--button"
        @click="openFilterDrawer"
      >
        <svg
          class="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line
            x1="4"
            y1="6"
            x2="20"
            y2="6"
          ></line>

          <line
            x1="8"
            y1="12"
            x2="16"
            y2="12"
          ></line>

          <line
            x1="11"
            y1="18"
            x2="13"
            y2="18"
          ></line>
        </svg>

        Filter
      </el-button>

      <el-input
        class="filter--input"
        v-model="state.searchValue"
        prefix-icon="el-icon-search"
        placeholder="Search"
        autocomplete="off"
        clearable
        @keyup.enter.native="goGoodsSearch"
        @clear="goGoodsSearch"
      />
    </div>

    <!-- 筛选抽屉 -->

    <el-drawer
      :visible.sync="state.filterDrawerOpen"
      direction="ltr"
      :with-header="false"
      size="400px"
      custom-class="filter-drawer"
      append-to-body
    >
      <div
        class="fd"
        @wheel.stop
      >
        <div class="fd-head">
          <h2 class="fd-title">
            Filters
          </h2>

          <button
            type="button"
            class="fd-close"
            aria-label="close filters"
            @click="closeFilterDrawer"
          >
            <i class="el-icon-close"></i>
          </button>
        </div>

        <div class="fd-body">
          <!-- 排序筛选 -->
          <section class="fd-sec">
            <button
              type="button"
              class="fd-sec-hd"
              @click="toggleSec('sort')"
            >
              <span class="fd-sec-tit">
                SORT BY
              </span>

              <span class="fd-sec-icon">
                {{ state.secOpen.sort ? '−' : '+' }}
              </span>
            </button>

            <div
              v-show="state.secOpen.sort"
              class="fd-sec-bd"
            >
              <label
                v-for="opt in sortOpts"
                :key="opt.id"
                class="fd-opt"
              >
                <input
                  v-model="state.sortBy"
                  type="radio"
                  class="fd-opt-inp"
                  :value="opt.id"
                />

                <span class="fd-radio"></span>

                <span class="fd-opt-txt">
                  {{ opt.label }}
                </span>
              </label>
            </div>
          </section>

          <!-- 分类筛选 -->
          <section class="fd-sec">
            <button
              type="button"
              class="fd-sec-hd"
              @click="toggleSec('cat')"
            >
              <span class="fd-sec-tit">
                CATEGORIES
              </span>

              <span class="fd-sec-icon">
                {{ state.secOpen.cat ? '−' : '+' }}
              </span>
            </button>

            <div
              v-show="state.secOpen.cat"
              class="fd-sec-bd"
            >
              <div
                v-for="parent in catTree"
                :key="parent.id"
                class="fd-cat-item"
              >
                <div class="fd-cat-row">
                  <label
                    class="fd-cat-lbl"
                    @click.prevent="toggleParentCat(parent)"
                  >
                    <input
                      type="checkbox"
                      class="fd-opt-inp"
                      :checked="isParentChecked(parent)"
                      readonly
                    />

                    <span
                      class="fd-chk"
                      :class="catChkCls(parent)"
                    ></span>

                    <span class="fd-opt-txt">
                      {{ parent.label }}
                    </span>
                  </label>

                  <i
                    v-if="parent.hasSubs"
                    class="el-icon-arrow-down fd-cat-arr"
                    :class="{ 'is-open': isCatOpen(parent.id) }"
                    @click.stop="toggleCatExpand(parent.id)"
                  ></i>
                </div>

                <div
                  v-if="parent.hasSubs"
                  v-show="isCatOpen(parent.id)"
                  class="fd-cat-sub"
                >
                  <label
                    v-for="child in parent.children"
                    :key="child.id"
                    class="fd-opt fd-cat-sub-item"
                    @click.prevent="toggleChildCat(child.id)"
                  >
                    <input
                      type="checkbox"
                      class="fd-opt-inp"
                      :checked="isCatSel(child.id)"
                      readonly
                    />

                    <span
                      class="fd-chk"
                      :class="{ 'is-checked': isCatSel(child.id) }"
                    ></span>

                    <span class="fd-opt-txt">
                      {{ child.label }}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </section>

          <!-- 品牌筛选 -->
          <section class="fd-sec">
            <button
              type="button"
              class="fd-sec-hd"
              @click="toggleSec('brand')"
            >
              <span class="fd-sec-tit">
                BRANDS
              </span>

              <span class="fd-sec-icon">
                {{ state.secOpen.brand ? '−' : '+' }}
              </span>
            </button>

            <div
              v-show="state.secOpen.brand"
              class="fd-sec-bd"
            >
              <label
                v-for="opt in brandOpts"
                :key="opt.id"
                class="fd-opt"
              >
                <input
                  v-model="state.selBrands"
                  type="checkbox"
                  class="fd-opt-inp"
                  :value="opt.id"
                />

                <span class="fd-chk"></span>

                <span class="fd-opt-txt">
                  {{ opt.label }}
                </span>
              </label>
            </div>
          </section>

          <!-- 品质 -->
          <section
            class="fd-sec"
            style="border: none;"
          >
            <button
              type="button"
              class="fd-sec-hd"
              @click="toggleSec('quality')"
            >
              <span class="fd-sec-tit">
                QUALITY
              </span>

              <span class="fd-sec-icon">
                {{ state.secOpen.quality ? '−' : '+' }}
              </span>
            </button>

            <div
              v-show="state.secOpen.quality"
              class="fd-sec-bd"
            >
              <label
                v-for="opt in qualityOpts"
                :key="opt.id"
                class="fd-opt"
              >
                <input
                  v-model="state.selQualities"
                  type="checkbox"
                  class="fd-opt-inp"
                  :value="opt.id"
                />

                <span class="fd-chk"></span>

                <span class="fd-opt-txt">
                  {{ opt.label }}
                </span>
              </label>
            </div>
          </section>
        </div>

        <div class="fd-foot">
          <button
            type="button"
            class="fd-btn fd-btn--outline"
            @click="clearAll"
          >
            Clear All
          </button>

          <button
            type="button"
            class="fd-btn fd-btn--primary"
            @click="viewResults"
          >
            View Results
          </button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import productApi from '@/api/product'
import { getGoodsCategoryList } from '@/api/cache'

// 静态筛选数据，后续可替换为接口
const SORT_OPTS = [
    { id: 'new', label: 'New Arrivals' },
    { id: 'priceHtL', label: 'Price High To Low' },
    { id: 'priceLtH', label: 'Price Low To High' },
    { id: 'AtZ', label: 'A-Z Asc' },
    { id: 'ZtA', label: 'Z-A Desc' }
]

export default {

    name: 'FilterGoods',

    props: {
        // 达人 ID，用于拉取商品分类
        expertId: {
            type: Number,
            default: null
        },
        // 默认一级分类 ID
        defaultParentCateIds: {
            type: String,
            default: ''
        },
        // 默认二级分类 ID
        defaultCateIds: {
            type: String,
            default: ''
        },
        // 关键词
        keyword: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            sortOpts: SORT_OPTS,
            catTree: [],
            brandOpts: [],
            qualityOpts: [],

            state: {
                searchValue: '',
                filterDrawerOpen: false,
                sortBy: '',
                selCats: [],
                selBrands: [],
                selQualities: [],
                catExpand: {},
                secOpen: {
                    sort: true,
                    cat: false,
                    brand: false,
                    quality: false,
                }
            }
        }
    },

    watch: {
        expertId: {
            immediate: true,
            handler(id) {
                if (id) {
                    this.getGoodsCategory()
                    this.getGoodsBrand()
                    this.getGoodsQuality()
                }
            }
        },
        // 关键词变化时同步
        keyword: {
            immediate: true,
            handler(val) {
                this.state.searchValue = val
            }
        },
        // 父级分类 ID 变化时同步勾选
        defaultParentCateIds: {
            immediate: true,
            handler(val) {
                this.applyDefaultCatById(val, this.defaultCateIds)
            }
        },

        defaultCateIds: {
            immediate: true,
            handler(val) {
                this.applyDefaultCatById(this.defaultParentCateIds, val)
            }
        },

        // 分类树加载后再同步，避免先于 catTree 到达时勾选失败
        catTree: {
            deep: true,
            handler() {
                this.applyDefaultCatById(this.defaultParentCateIds, this.defaultCateIds)
            }
        }
    },

    methods: {
        // 获取商品分类
        async getGoodsCategory() {
            const res = await getGoodsCategoryList(this.expertId)
            const list = res.data || []
            if (list.length === 0) {
                this.catTree = []
                return
            }

            this.catTree = this.buildCatTree(list)
            this.applyDefaultCatById(this.defaultParentCateIds, this.defaultCateIds)
        },

        // 构建分类树（展示所有分类，包括没有商品的）
        buildCatTree(list) {
            return list.map(item => {
                    const children = (item.subCategoryList || [])
                        .map(sub => ({
                            id: sub.id,
                            label: sub.categoryName
                        }))
                    const hasSubs = children.length > 0
                    return {
                        id: item.id,
                        label: item.categoryName,
                        hasSubs,
                        children
                    }
                })
        },

        // 获取所有可选叶子分类 ID（有子级取子级 ID，无子级取父级 ID）
        // 统一返回字符串类型，避免类型不匹配
        getAllLeafCatIds() {
            const ids = []
            this.catTree.forEach(parent => {
                if (parent.hasSubs) {
                    parent.children.forEach(child => ids.push(String(child.id)))
                } else {
                    ids.push(String(parent.id))
                }
            })
            return ids
        },

        // 获取父级下所有子分类 ID
        // 统一返回字符串类型，避免类型不匹配
        getParentChildIds(parent) {
            return parent.hasSubs ? parent.children.map(c => String(c.id)) : [String(parent.id)]
        },

        // 分类是否已选（使用 ID）
        isCatSel(id) {
            return this.state.selCats.includes(String(id))
        },

        // 父级是否全选
        isParentChecked(parent) {
            const ids = this.getParentChildIds(parent)
            return ids.length > 0 && ids.every(id => this.isCatSel(id))
        },

        // 父级是否半选
        isParentInd(parent) {
            if (!parent.hasSubs) return false
            const names = parent.children.map(c => String(c.id))
            const selCnt = names.filter(name => this.isCatSel(name)).length
            return selCnt > 0 && selCnt < names.length
        },

        // 父级勾选样式
        catChkCls(parent) {
            if (this.isParentInd(parent)) return { 'is-ind': true }
            if (this.isParentChecked(parent)) return { 'is-checked': true }
            return {}
        },

        // 子级分类是否展开
        isCatOpen(id) {
            return !!this.state.catExpand[id]
        },

        // 展开/收起子级分类
        toggleCatExpand(id) {
            this.$set(this.state.catExpand, id, !this.state.catExpand[id])
        },

        // 切换单个分类选中（使用 ID）
        toggleCatName(id) {
            const idStr = String(id)
            const idx = this.state.selCats.indexOf(idStr)
            if (idx > -1) {
                this.state.selCats.splice(idx, 1)
            } else {
                this.state.selCats.push(idStr)
            }
        },

        // 切换父级分类（有子级时联动子级，仅传子级 ID）
        toggleParentCat(parent) {
            const ids = this.getParentChildIds(parent)
            const allSel = ids.every(id => this.isCatSel(id))
            if (allSel) {
                this.state.selCats = this.state.selCats.filter(n => !ids.includes(n))
                return
            }
            const set = new Set([...this.state.selCats, ...ids])
            this.state.selCats = [...set]
        },

        // 切换子级分类
        toggleChildCat(id) {
            this.toggleCatName(id)
        },

        // 根据分类 ID 勾选筛选项
        // 规则：
        // 1. 只传 parentCateIds（无子级）：选择父级下的全部子级
        // 2. 同时传 parentCateIds 和 cateIds：只选择指定的子级，不自动选择其他子级
        applyDefaultCatById(parentCateIds, cateIds) {
            const parentRaw = typeof parentCateIds === 'string' ? parentCateIds.trim() : ''
            const cateRaw = typeof cateIds === 'string' ? cateIds.trim() : ''
            
            // 都为空时清空选中
            if ((!parentRaw || parentRaw.toLowerCase() === 'all') && (!cateRaw || cateRaw.toLowerCase() === 'all')) {
                this.state.selCats = []
                return
            }
            
            if (!this.catTree.length) {
                // 分类树未就绪，先保留待选项 ID，等 catTree 监听再匹配
                this.state.selCats = []
                return
            }
            
            // 获取所有叶子分类 ID（有子级取子级 ID，无子级取父级 ID）
            const leafIds = this.getAllLeafCatIds()
            console.log('applyDefaultCatById debug:', {
                parentRaw,
                cateRaw,
                catTree: JSON.stringify(this.catTree),
                leafIds
            })
            const picked = []
            
            // 如果传了子级 ID，只选择指定的子级（不自动选择父级下的全部子级）
            if (cateRaw && cateRaw.toLowerCase() !== 'all') {
                const childIds = cateRaw.split(',').map(s => s.trim()).filter(Boolean)
                let hasValidChild = false
                
                childIds.forEach(cid => {
                    const cidStr = String(cid)
                    if (leafIds.includes(cidStr)) {
                        picked.push(cidStr)
                        hasValidChild = true
                    } else {
                        // 子级 ID 不在叶子节点中，可能是被过滤掉了（没有商品）
                        // 尝试查找其父级分类
                        let foundParent = false
                        this.catTree.forEach(parent => {
                            if (parent.hasSubs && parent.children.some(child => String(child.id) === cidStr)) {
                                // 找到父级，添加这个子级
                                picked.push(cidStr)
                                hasValidChild = true
                                foundParent = true
                            }
                        })
                        if (!foundParent) {
                            console.warn('分类 ID ' + cidStr + ' 不在分类树中，可能已被过滤（无商品）')
                        }
                    }
                })
                
                // 如果没有有效的子级被选中，但有父级 ID，回退到父级选择
                if (!hasValidChild && parentRaw && parentRaw.toLowerCase() !== 'all') {
                    const parentIds = parentRaw.split(',').map(s => s.trim()).filter(Boolean)
                    parentIds.forEach(pid => {
                        const parent = this.catTree.find(p => String(p.id) === String(pid))
                        if (parent) {
                            if (parent.hasSubs) {
                                picked.push(...parent.children.map(c => String(c.id)))
                            } else {
                                picked.push(String(parent.id))
                            }
                        }
                    })
                }
            } else if (parentRaw && parentRaw.toLowerCase() !== 'all') {
                // 只传了父级 ID，选择父级下的全部子级
                const parentIds = parentRaw.split(',').map(s => s.trim()).filter(Boolean)
                parentIds.forEach(pid => {
                    const parent = this.catTree.find(p => String(p.id) === String(pid))
                    if (parent) {
                        if (parent.hasSubs) {
                            // 有子级：添加所有子级 ID（父级选中状态由 isParentChecked 计算）
                            picked.push(...parent.children.map(c => String(c.id)))
                        } else {
                            // 无子级：直接添加父级 ID（它本身就是叶子节点）
                            picked.push(String(parent.id))
                        }
                    } else if (leafIds.includes(String(pid))) {
                        // 找不到父级，可能是独立分类，作为叶子节点处理
                        picked.push(String(pid))
                    }
                })
            }
            
            const valid = [...new Set(picked)]
            this.state.selCats = valid
            
            // 有选中子级时自动展开对应父级
            this.catTree.forEach(parent => {
                if (parent.hasSubs && parent.children.some(c => valid.includes(c.id))) {
                    this.$set(this.state.catExpand, parent.id, true)
                }
            })
        },

        // 获取品牌
        async getGoodsBrand() {
            const res = await productApi.getGoodsBrandList({ expertId: this.expertId })
            const list = res.data || []
            if (list.length === 0) {
                this.brandOpts = []
                return
            }

            this.brandOpts = list.map(item => ({
                id: item.brandName,
                label: item.brandName
            }))
        },

        // 获取商品品质
        async getGoodsQuality() {
            const res = await productApi.getGoodsTagList({ expertId: this.expertId })
            const list = res.data || []
            if (list.length === 0) {
                this.qualityOpts = []
                return
            }

            this.qualityOpts = list.map(item => ({
                id: item.tag,
                label: item.tag
            }))
        },

        // 搜索
        goGoodsSearch() {
            this.$emit('goGoodsSearch', this.state.searchValue)
        },

        // 打开筛选抽屉
        openFilterDrawer() {
            this.state.filterDrawerOpen = true
        },

        // 关闭筛选抽屉
        closeFilterDrawer() {
            this.state.filterDrawerOpen = false
        },

        // 折叠/展开分区
        toggleSec(key) {
            this.state.secOpen[key] = !this.state.secOpen[key]
        },

        // 重置全部筛选
        clearAll() {
            this.state.sortBy = ''
            this.state.selCats = []
            this.state.selBrands = []
            this.state.selQualities = []
        },

        // 应用筛选并关闭抽屉
        viewResults() {
            // 分离一级和二级分类 ID
            const parentIds = new Set()
            const childIds = []
            
            this.state.selCats.forEach(id => {
                // 查找该 ID 属于哪个父级
                for (const parent of this.catTree) {
                    if (String(parent.id) === String(id)) {
                        // 是父级 ID
                        parentIds.add(id)
                        return
                    }
                    if (parent.hasSubs && parent.children.some(c => String(c.id) === String(id))) {
                        // 是子级 ID，同时需要记录其父级 ID
                        parentIds.add(parent.id)
                        childIds.push(id)
                        return
                    }
                }
                // 如果找不到父级，可能是独立分类，作为父级处理
                parentIds.add(id)
            })
            
            // 如果选择了父级但没有选择任何子级，说明是选择了整个父级分类
            // 此时 childIds 应该为空，parentIds 包含父级 ID
            // 如果选择了父级的部分子级，childIds 包含这些子级 ID
            
            this.$emit('filterApply', {
                sortBy: this.state.sortBy,
                parentCateIds: [...parentIds],
                cateIds: [...childIds],
                brands: [...this.state.selBrands],
                qualities: [...this.state.selQualities]
            })
            this.closeFilterDrawer()
        }
    }
}

</script>

<style scoped lang="scss">
.filter-goods__wrap {
    max-width: 1200px;
    padding: 20px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;

    .filter--button {
        flex: none;
        padding: 8px 12px;
        border-radius: 12px;
        border: 1px solid var(--select-border-color);
        color: var(--select-color);
        background: transparent;

        :deep(span) {
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
                display: inline-block;
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }
    }

    .filter--button:hover,
    .filter--button:active,
    .filter--button:focus {
        color: var(--primary-color);
        border-color: hsl(var(--primary-color), 0.5);
        background-color: hsl(var(--primary-color), 0.1);
    }

    .filter--input {
        max-width: 400px;

        :deep(.el-input__inner) {
            border-radius: 12px;
            border: 1px solid hsl(from var(--select-border-color) h s l / 0.8);
            background-color: hsl(from var(--select-border-color) h s l / 0.5);
        }
    }
}

.fd {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    color: var(--text-color);
    background: var(--background-color);
}

.fd-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    padding: 20px 24px;
    border-bottom: 1px solid var(--link-color);
}

.fd-title {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
}

.fd-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid var(--link-color);
    border-radius: 4px;
    background: var(--background-color);
    cursor: pointer;
    transition: border-color 0.15s;

    i {
        font-size: 14px;
        color: var(--select-color);
    }

    &:hover {
        border-color: var(--select-color);
    }
}

.fd-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    /* 滚到底/顶时不把滚动链传到页面 */
    overscroll-behavior: contain;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
}

.fd-sec {
    border-bottom: 1px solid var(--link-color);
}

.fd-sec-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 38px 24px;
    border: none;
    color: var(--select-color);
    background: transparent;
    cursor: pointer;
    text-align: left;
    outline: none;
    /* 去掉移动端手按时的默认高亮 */
    -webkit-tap-highlight-color: transparent;

    &:hover,
    &:focus,
    &:focus-visible,
    &:active {
        color: var(--select-color);
        background: transparent;
        outline: none;
    }
}

.fd-sec-tit {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: var(--select-color);
}

.fd-sec-icon {
    font-size: 18px;
    font-weight: 300;
    line-height: 1;
    color: hsl(from var(--select-color) h s l / 0.8);
}

.fd-sec-bd {
    padding: 0 24px 20px;
}

.fd-opt {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 0;
    cursor: pointer;
    user-select: none;
    /* 去掉移动端点击时的默认高亮背景 */
    -webkit-tap-highlight-color: transparent;

    &:active,
    &:focus,
    &:focus-within {
        background: transparent;
        outline: none;
    }
}

.fd-opt-inp {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
    outline: none;
}

.fd-opt-txt {
    font-size: 15px;
    line-height: 1.4;
    color: var(--select-color);
    font-weight: 500;
}

.fd-radio {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 1.5px solid var(--link-color);
    border-radius: 50%;
    transition: border-color 0.15s, box-shadow 0.15s;
}

.fd-opt-inp:checked+.fd-radio {
    border-color: var(--primary-color);
    box-shadow: inset 0 0 0 4px var(--primary-color);
}

.fd-chk {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 1.5px solid var(--link-color);
    border-radius: 2px;
    transition: background 0.15s, border-color 0.15s;
}

.fd-opt-inp:checked+.fd-chk {
    border-color: var(--primary-color);
    background: var(--primary-color);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10'%3E%3Cpath fill='none' stroke='%23fff' stroke-width='2' d='M1 5l3 3 7-7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 8px;
}

.fd-chk.is-checked {
    border-color: var(--primary-color);
    background: var(--primary-color);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10'%3E%3Cpath fill='none' stroke='%23fff' stroke-width='2' d='M1 5l3 3 7-7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 8px;
}

.fd-chk.is-ind {
    border-color: var(--primary-color);
    background: var(--primary-color);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 2'%3E%3Cpath fill='none' stroke='%23fff' stroke-width='2' d='M1 1h10'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px 2px;
}

.fd-cat-item {
    &:last-child {
        border-bottom: none;
    }
}

.fd-cat-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 14px 0;
}

.fd-cat-lbl {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
    cursor: pointer;
    user-select: none;
    /* 去掉移动端点击时的默认高亮背景 */
    -webkit-tap-highlight-color: transparent;

    &:active,
    &:focus,
    &:focus-within {
        background: transparent;
        outline: none;
    }
}

.fd-cat-arr {
    flex-shrink: 0;
    font-size: 14px;
    color: var(--select-color);
    cursor: pointer;
    transition: transform 0.2s;

    &.is-open {
        transform: rotate(180deg);
    }
}

.fd-cat-sub {
    padding: 0 0 4px 30px;
}

.fd-cat-sub-item {
    padding: 12px 0;
}

.fd-foot {
    display: flex;
    gap: 12px;
    flex-shrink: 0;
    padding: 16px 24px 20px;
    border-top: 1px solid var(--link-color);
}

.fd-btn {
    flex: 1;
    height: 44px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    transition: opacity 0.15s, background 0.15s;

    &--outline {
        color: var(--select-color);
        border: 1px solid hsl(from var(--select-color) h s l / 0.2);
        background: var(--background-color);

        &:hover {
            background: hsl(from var(--select-color) h s l / 0.1);
        }
    }

    &--primary {
        color: #fff;
        border: 1px solid var(--primary-color);
        background: var(--primary-color);

        &:hover {
            opacity: 0.88;
        }
    }
}

@media (max-width: 768px) {
    .filter-goods__wrap {
        padding: 10px;
    }
}
</style>

<style lang="scss">
.filter-drawer {
    overscroll-behavior: contain;

    .el-drawer__body {
        padding: 0;
        height: 100%;
        overflow: hidden;
        overscroll-behavior: contain;
    }

    /* append-to-body，提高优先级覆盖全局 scrollbar 样式 */
    .fd-body {
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
            display: none;
        }
    }
}

@media (max-width: 768px) {
    .filter-drawer.el-drawer.ltr {
        width: 86% !important;
    }
}
</style>
